import _ from "lodash";
//import Vue from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import { checkUserData } from "./helpers/user";
import store from "./store";
import axios from "axios";

//Vue.use(Router);

const router = new createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "Home",
    //   component: () => import("./components/auth/Login.vue"),
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    {
      path: "/",
      name: "Home",
      component: () => import("./components/home/Front.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    // {
    //   path: "/about",
    //   name: "About",
    //   component: () => import("./views/About.vue"),
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    {
      path: "/login",
      name: "Login",
      component: () => import("./components/auth/Login.vue"),
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("./components/auth/Register.vue"),
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/front",
      name: "Front",
      component: () => import("./components/home/Front.vue"),
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/register/t/:id",
      name: "RegsiterTele",
      component: () => import("./components/auth/Register.vue"),
      props: true,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/verify-account",
      name: "VerifyAccount",
      component: () => import("./components/auth/VerifyAccount.vue"),
      meta: {
        requiresAuth: false,
      },
    },

    {
      path: "/user/:handle",
      name: "UserProfile",
      component: () => import("./components/user/UserProfile.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    // {
    //   path: "/user/:handle/edit",
    //   name: "EditUserProfile",
    //   component: () => import("./components/user/EditUserProfile.vue"),
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     transitionName: "router-anim",
    //     enterActive: "animated fadeIn",
    //   },
    // },
    // {
    //   path: "/rooms",
    //   name: "RoomList",
    //   component: () => import("./components/room/RoomList.vue"),
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     transitionName: "router-anim",
    //     enterActive: "animated fadeIn",
    //   },
    // },
    {
      path: "/room/:id",
      name: "Room",
      component: () => import("./components/room/Room.vue"),
      meta: {
        requiresAuth: true,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    {
      path: "/Chatroom/:id",
      name: "Chatroom",
      component: () => import("./components/Chatroom.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    {
      path: "/voting",
      name: "Voting",
      component: () => import("./views/Voting.vue"),
      meta: {
        requiresAuth: false,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    {
      path: "/group-chat",
      name: "GroupChat",
      component: () => import("./views/GroupChat.vue"),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    {
      path: "/character/:id",
      name: "CharacterProfile", 
      component: () => import("./views/CharacterProfile.vue"),
      props: true,
      meta: {
        requiresAuth: false,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    {
      path: "/post/:id",
      name: "PostDetail",
      component: () => import("./views/PostDetail.vue"),
      props: true,
      meta: {
        requiresAuth: false,
        transitionName: "router-anim",
        enterActive: "animated fadeIn",
      },
    },
    // {
    //   path: "/Chatroom/",
    //   name: "Chatroom",
    //   component: () => import("./components/Chatroom.vue"),
    //   meta: {
    //     requiresAuth: true,
    //     transitionName: "router-anim",
    //     enterActive: "animated fadeIn",
    //   },
    // },
    {
      path: "/404",
      name: "NotFound",
      component: () => import("./views/NotFound.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/:catchAll(.*)", // 不识别的path自动匹配404
      redirect: "/404",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  await checkUserData(next);
  if (to.meta.requiresAuth) {
    if (localStorage.getItem("authToken") === null) {
      localStorage.clear();
      next({
        name: "Login",
        params: { message: "You are unauthorized, Please login to access" },
      });
    } else {
      // Check admin access if required
      if (to.meta.requiresAdmin) {
        const userData = store.getters.getUserData;
        console.log('Router admin check - User data:', {
          hasUserData: !!userData,
          userId: userData?._id,
          isAdmin: userData?.isAdmin,
          handle: userData?.handle
        });
        
        // If no user data in store, try to fetch it first
        if (!userData || !userData._id) {
          const authToken = localStorage.getItem("authToken");
          if (authToken) {
            try {
              const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/user/current`, {
                headers: {
                  'Authorization': `Bearer ${authToken}`
                }
              });
              
              if (response.data) {
                // Save to store
                store.dispatch('saveUserData', response.data);
                store.dispatch('toggleAuthState', true);
                console.log('Router: User data fetched and saved to store');
                
                // Now check admin status
                if (!response.data.isAdmin) {
                  console.log('Router: User is not admin, redirecting');
                  next({
                    name: "Home",
                    params: { message: "Admin access required" },
                  });
                  return;
                }
              }
            } catch (error) {
              console.error('Router: Failed to fetch user data:', error);
              next({
                name: "Login",
                params: { message: "Please log in again" },
              });
              return;
            }
          } else {
            next({
              name: "Login",
              params: { message: "Please log in to access this page" },
            });
            return;
          }
        } else if (!userData.isAdmin) {
          console.log('Router: User is not admin, redirecting');
          next({
            name: "Home",
            params: { message: "Admin access required" },
          });
          return;
        }
        
        console.log('Router: Admin access granted');
      }
      next();
    }
  } else if (!_.isEmpty(to.meta) && !to.meta.requiresAuth) {
    if (localStorage.getItem("authToken")) {
      next({
        name: "UserProfile",
        params: { handle: store.getters.getUserData.handle },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
